// @ts-ignore
import('./main');
